import { render, staticRenderFns } from "./WeekdaySelection.vue?vue&type=template&id=7496d3c0&scoped=true"
import script from "./WeekdaySelection.vue?vue&type=script&lang=js"
export * from "./WeekdaySelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7496d3c0",
  null
  
)

export default component.exports